var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.059 16.1021C25.059 11.0752 29.1342 7 34.1612 7C39.1881 7 43.2633 11.0752 43.2633 16.1021C43.2633 21.1291 39.1881 25.2043 34.1612 25.2043C29.1342 25.2043 25.059 21.1291 25.059 16.1021ZM34.1612 10.8684C31.2707 10.8684 28.9274 13.2116 28.9274 16.1021C28.9274 18.9927 31.2707 21.3359 34.1612 21.3359C37.0517 21.3359 39.3949 18.9927 39.3949 16.1021C39.3949 13.2116 37.0517 10.8684 34.1612 10.8684Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7489 33.9821C21.3784 29.8282 26.0141 27.0702 31.294 27.0702H37.0283C45.2223 27.0702 51.8648 33.7128 51.8648 41.9067V48.1417H28.1177C29.1751 46.8774 29.9652 45.5885 30.4683 44.2733H47.9964V41.9131L47.9818 41.3351C47.7037 35.9143 43.4885 31.5325 38.1404 30.9943L37.576 30.9522L37.0222 30.9386H31.3003L30.7223 30.9533C28.5461 31.0649 26.5374 31.8111 24.8775 33.0104C24.5862 32.972 24.2884 32.9516 23.9848 32.9504C22.4276 32.9503 21.4039 33.1395 20.233 33.7126C19.8874 33.8818 19.5581 34.0786 19.2465 34.3026C19.0854 34.1888 18.9194 34.0819 18.7489 33.9821Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5425 34.6987C11.1944 34.6987 9 37.4867 9 40.8574C9 43.7086 10.7313 46.4604 13.6215 49.0599C15.1676 50.4504 17.1364 51.8431 18.6051 52.6438L19.2586 53L19.9121 52.6438C21.3807 51.8431 23.3496 50.4504 24.8956 49.0599C27.7859 46.4604 29.5172 43.7086 29.5172 40.8574C29.5172 37.5261 27.2916 34.7124 23.9841 34.6987H23.9785C22.7033 34.6987 21.8671 34.8278 20.8848 35.3086C20.292 35.5987 19.7676 35.9899 19.3157 36.4803L19.255 36.5461L19.1943 36.4813C18.7501 36.0075 18.2343 35.627 17.6536 35.3398C16.6562 34.8465 15.7806 34.6987 14.5425 34.6987Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.0d3ea5e3.svg";
export { ForwardRef as ReactComponent };